const excludedPasswords = [
  'amex',
  'aexp',
  '12345678',
  '987654321',
  '2626569873',
  '2796829365',
  '!@#$%^&*',
  '1q2w3e4r5t',
  '1qaz2wsx',
  'serve',
  'password',
  'axp',
  'bluebird',
  'bluebox',
  'centurion',
  'express',
  'open',
  'plenti',
  'redbird',
  'redcard',
  'whatever',
  'qwerty',
  'american',
  'aa123456',
  'abcd1234',
  'adobe123',
  'babygirl',
  'baseball',
  'basketball',
  'butterfly',
  'bvttes123',
  'trustno1',
  'asdfgh',
  'chegg123',
  'chocolate',
  'dubsmash',
  'football',
  'g_czechout',
  'iloveyou',
  'jennifer',
  'liverpool',
  'livetest',
  'michelle',
  'zxcvbn',
  'passw0rd',
  'photoshop',
  'princess',
  'q1w2e3r4t5y6',
  'samantha',
  'shopping',
  'starwars',
  'sunshine',
  'superman',
  'zaq1zaq1',
  '2967088856',
  '123456',
  '000000',
  '123',
  '1234',
  '111111',
  'Status',
  '123456789',
  '1234567891',
  '1234567',
  'nicolas',
  'julien',
  'azerty',
  'doudou',
  'azertyuiop',
  '123123',
  'jetaime',
  'thomas',
  '1234561',
  '12345',
  'soleil',
  '123451',
  'coucou',
  'camille',
  'marseille',
  'loulou',
  'chouchou',
  'bonjour',
  'motdepasse',
  '010203',
];

const constraints = {
  CONTACT_NM_REGEX: /^(?![ ,._-])(?!.*[ ,._-]$)[\w ,.-]+$/,
  CONTACT_NM_MAX: 30,
  CONTACT_NM_MIN: 6,
  PHONE_NO_REGEX: /^(?! )(?!.*[ ()+-/]$)[\d ()+-/]+$/,
  PHONE_NO_REGEX_END: /^.*(\d\)|\d|\s)$/,
  PHONE_NO_REGEX_ALLOWED: /^[\d ()+/-]+$/,
  PHONE_NO_MAX: 20,
  PHONE_NO_MIN: 7,

  USER_IDENTIFIER_REGEX: /^(?:(?![ :]).)+$/,
  USER_IDENTIFIER_MAX: 32,
  USER_IDENTIFIER_MIN: 5,

  /**
   * Validation -
   * Allow space within string
   * Disallow spaces at beginning & ending
   * Minimum length - 8 (keeping min length to 0 here for user error messages) and max length - 256
   * Disallow place-holder characters
   */
  CREDENTIAL_PASSWORD_COMMON_REGEX: `^(?![ ])(?!.*(${excludedPasswords.join('|')}))[\\s\\S]{0,256}(?<![ ])$`,
  // CREDENTIAL_PASSWORD_COMMON_REGEX: `^(?!.*${excludedPasswords.join('|')}).*$`,
  // CREDENTIAL_PASSWORD_REGEX: `/^[^\s]+(\s+[^\s]+)*$/`,
  CREDENTIAL_PASSWORD_REGEX: '/^(?![ ])(?!.*[ ]$).+$/',
  CREDENTIAL_PASSWORD_MAX: 256,
  CREDENTIAL_PASSWORD_MIN: 8,

  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%*@^_-])([\w!#$%*@^-])+$/,
  PASSWORD_COMMON_REGEX: /^(?!.*(([Aa|][Mm|][Ee|][Xx|])|([Qq|][Ww|][Ee|][Rr|][Tt|][Yy|])|([Pp|][Aa|][Ss|]{2}[Ww|][Oo|][Rr|][Dd|])|([Aa|][Bb|][Cc|])|([Pp|]@[Ss|]{2}[Ww|][Oo|][Rr|][Dd|]))).*$/,
  PASSWORD_MAX: 40,
  PASSWORD_MIN: 8,

  EMAIL_REGEX: /^[\w!#$%&*+./=?^`{|}~’-]+@[\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*$/,
  EMAIL_NOT_AEXP_REGEX: /^.*(?<!aexp.com)$/i,

  EMAIL_MAX: 64,
  EMAIL_MIN: 6,

  OTP_LIMIT: 6,
  SECURITY_PIN_MIN: 6,
  SECURITY_PIN_MAX: 9,

  NUMERIC_REGEX: /^\d+$/,

};

export default constraints;
